module.exports = __webpack_public_path__ + "static/media/Stephanie Derzypolski Logo.0eb041a6.jpeg";